// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c268b60","453":"0da5b5fe","732":"82a3dfae"}[chunkId] + ".chunk.js";
};